import { DataGrid } from '@mui/x-data-grid';

export const GenericTable = ({
    columns,
    rows
}: any) => {
    return (
        <div>
            <DataGrid
                autoHeight
                sx={{
                    '.MuiDataGrid-columnHeaders': {
                        backgroundColor: '#003883',
                        color: '#fff'
                    },
                    '.MuiDataGrid-menuIcon .MuiSvgIcon-root': {
                        color: '#fff'
                    },
                    '.MuiDataGrid-iconButtonContainer .MuiSvgIcon-root': {
                        color: '#fff'
                    }
                }}
                columns={columns}
                rows={rows}
                checkboxSelection={false}
                pageSize={10}
                rowsPerPageOptions={[]}
                pagination
            />
        </div >
    );
}
